<template>
  <div>
    <div>
      <!-- Clase Title-->
      <div v-if="isLoading" class="container-fluid">
        <!-- <h5>Cargando</h5> -->
        <h6>{{ loadingMsg }}</h6>
        <b-col>
          <b-row id="progress-row">
            <b-progress v-if="loadingProgress.status" :value="loadingProgress.value" :variant="loadingProgress.color"
              :max=100 show-progress animated class="w-100"></b-progress>
          </b-row>
        </b-col>
      </div>
      <div v-if="!isLoading" class="container-fluid">
        <!-- <h5>Cargando</h5> -->
      </div>
      <div v-if="!isLoadingClassInfo">
        <b-row>
          <b-col>
            <h3 class="mt-3">
              {{ claseTitle }} | {{ clase.x_teacher_id[1] }} - {{ clase.x_room_id[1] }}
              <b-badge v-if="clase.x_advanced_class" pill variant="info">Avanzado</b-badge>
            </h3>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" md="4" lg="4">
            <b-card class="mb-4">
              <b-row>
                <b-col cols="3">
                  <b-avatar size="4rem" class="ml-1 mt-3" variant="primary">
                    <b-iconstack font-scale="2" title="Estudiantes">
                      <b-icon stacked variant="light" icon="person-fill" shift-h="-8"></b-icon>
                      <b-icon stacked variant="light" icon="person-fill" shift-h="0" shift-v="-4"></b-icon>
                      <b-icon stacked variant="light" icon="person-fill" shift-h="8"></b-icon>
                    </b-iconstack>
                  </b-avatar>
                </b-col>
                <b-col>
                  <h4 class="card-title mb-1">Estudiantes: {{ alumnosCursando }}</h4>
                  <b-card-text class="mb-2">Bajas: {{ alumnosBaja }} </b-card-text>
                  <b-progress :value="capacityPercentage.barValue" max="100" :variant="capacityPercentage.barColor"
                    show-progress animated></b-progress>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <b-card class="mb-4">
              <b-row>
                <b-col cols="3">
                  <b-avatar size="4rem" class="ml-1 mt-3" variant="primary" icon="journal-bookmark-fill">
                  </b-avatar>
                </b-col>
                <b-col>
                  <b-row>
                    <h6 class="my-1">
                      <b>Asistencia Mínima</b>:
                      {{ course.x_attendance }} %
                    </h6>
                  </b-row>
                  <b-row>
                    <h6 class="my-1">
                      <b>Nota Aprobación:</b>
                      {{ course.x_pass_score }}
                    </h6>
                  </b-row>
                  <b-row>
                    <h6 class="my-1">
                      <b>Nota Promoción:</b>
                      {{ course.x_prom_score }}
                    </h6>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
          <b-col cols="12" md="4" lg="4">
            <b-card class="mb-4">
              <b-row>
                <b-col cols="5">
                  <b-avatar size="4rem" class="ml-1 mt-3" variant="primary">
                    <b-iconstack font-scale="2" title="Exportar">
                      <b-icon stacked variant="light" icon="table" shift-h="-3"></b-icon>
                      <b-icon stacked variant="light" scale="0.7" icon="arrow-down-circle-fill" shift-h="6"
                        shift-v="-6"></b-icon>
                    </b-iconstack>
                  </b-avatar>
                </b-col>
                <b-col>
                  <b-row class="mt-2">
                    <export-excel class="btn btn-default" :data="export_json_data" :fields="export_json_fields"
                      :worksheet="claseTitle" :name="claseTitle +
        '-' +
        clase.x_teacher_id[1] +
        '-' +
        clase.x_room_id[1] +
        '.xls'
        ">
                      <b-button variant="outline-primary" size="m">Exportar Alumnos</b-button>
                    </export-excel>
                  </b-row>
                </b-col>
              </b-row>
            </b-card>
          </b-col>
        </b-row>

      </div>
      <div>
        <b-card v-if="!isLoading">
          <b-row style="margin-bottom: 15px">
            <b-col>
              <label for="">Periodo:</label> <br />
              <b-form-select v-model="selectedPeriod" :options="periodOptions"></b-form-select>
            </b-col>
            <b-col>
              <div v-if="periods[selectedPeriod]">
                <label for="">Fechas:</label> <br />
                <div style="font-size: 0.8em">
                  <b>{{ periods[selectedPeriod].x_start_date }}</b> al
                  <b>{{ periods[selectedPeriod].x_end_date }}</b>
                </div>
              </div>
            </b-col>
            <b-col>
              <div v-if="periods[selectedPeriod]">
                <b-row>
                  <label for="">Tareas:</label>
                </b-row>
                <b-row>
                  <b-col>
                    <b-input v-model="teacherNotes.x_homework_count"></b-input>
                  </b-col>
                  <b-col>
                    <b-button variant="outline-secondary" @click="EditarHomeworkCount()">Editar</b-button>
                  </b-col>
                </b-row>
              </div>
            </b-col>
            <b-col>
              <div v-if="periods[selectedPeriod]">
                <label for="">Acciones:</label> <br />
                <b-button @click="cargarNotas()" variant="outline-primary" v-if="!editItem">Cargar Notas</b-button>
                <b-button @click="cancelarCarga()" variant="outline-secondary" v-if="editItem"
                  style="margin-right: 5px">Cancelar</b-button>
                <b-button @click="guardarNotas()" variant="outline-primary" v-if="editItem">Guardar</b-button>
              </div>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-table sticky-header striped hover no-border-collapse head-variant="light" style="min-height: 60vh"
                :items="enrollments" :fields="enrollmentFields" :busy="isBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>
                <template #cell(x_student_id)="data">
                  <b-link @click="openMoreInfoModal(data.item)"><b>{{ data.index + 1 }}</b> |
                    {{ data.item.x_student_id[1] }}</b-link>
                  <b-link class="ml-2"
                    v-if="$store.state.user.currentGroups.includes('Dirección') || $store.state.user.currentGroups.includes('Billing')"
                    @click="gotoFamilia(data.item)">
                    <b-icon icon="arrow-up-right-square"></b-icon>
                  </b-link>
                  <b-icon
                    v-if="bestGPA > 0 && data.item.resumenCursada.Prom > 0 && data.item.resumenCursada.Prom == bestGPA"
                    variant="warning" class="ml-2" animation="fade" icon="trophy-fill"></b-icon>
                  <br>
                  <div v-if="data.item.x_GPA">
                    <div
                      v-if="data.item.resumenCursada.Prom > 0 && data.item.resumenCursada.Prom < course.x_pass_score">
                      <h6 style="margin:0">
                        <b-badge variant="danger">Prom.: {{ data.item.resumenCursada.Prom }}</b-badge>
                      </h6>
                    </div>
                    <div v-if="data.item.resumenCursada.Prom > 0 && data.item.resumenCursada.Prom >= course.x_pass_score &&
        data.item.resumenCursada.Prom <= course.x_prom_score
        ">
                      <h6 style="margin:0">
                        <b-badge variant="success">Prom.: {{ data.item.resumenCursada.Prom }}</b-badge>
                      </h6>
                    </div>
                    <div
                      v-if="data.item.resumenCursada.Prom > 0 && data.item.resumenCursada.Prom > course.x_prom_score">
                      <h6 style="margin:0">
                        <b-badge variant="info">Prom.: {{ data.item.resumenCursada.Prom }}</b-badge>
                      </h6>
                    </div>
                  </div>
                </template>

                <template #cell(Primer_Trimestre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Primer Trimestre'">
                      <div v-if="v.x_avg < course.x_pass_score">
                        <h6 style="margin:0">
                          <b-badge variant="danger">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg >= course.x_pass_score &&
        v.x_avg <= course.x_prom_score
        ">
                        <h6 style="margin:0">
                          <b-badge variant="success">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > course.x_prom_score">
                        <h6 style="margin:0">
                          <b-badge variant="info">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_homework_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_homework_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(Primer_Cuatrimestre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Primer Cuatrimestre'">
                      <div v-if="v.x_avg < course.x_pass_score">
                        <h6 style="margin:0">
                          <b-badge variant="danger">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg >= course.x_pass_score &&
        v.x_avg <= course.x_prom_score
        ">
                        <h6 style="margin:0">
                          <b-badge variant="success">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > course.x_prom_score">
                        <h6 style="margin:0">
                          <b-badge variant="info">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_homework_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_homework_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(Segundo_Cuatrimestre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Segundo Cuatrimestre'">
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg < course.x_pass_score">
                        <h6 style="margin:0">
                          <b-badge variant="danger">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg >= course.x_pass_score &&
        v.x_avg <= course.x_prom_score
        ">
                        <h6 style="margin:0">
                          <b-badge variant="success">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg > course.x_prom_score">
                        <h6 style="margin:0">
                          <b-badge variant="info">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_homework_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_homework_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(Segundo_Trimestre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Segundo Trimestre'">
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg < course.x_pass_score">
                        <h6 style="margin:0">
                          <b-badge variant="danger">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg >= course.x_pass_score &&
        v.x_avg <= course.x_prom_score
        ">
                        <h6 style="margin:0">
                          <b-badge variant="success">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > 0 && !Number.isNaN(v.x_avg) && v.x_avg > course.x_prom_score">
                        <h6 style="margin:0">
                          <b-badge variant="info">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_homework_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_homework_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_attendance_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(Tercer_Trimestre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Tercer Trimestre'">
                      <div v-if="v.x_avg < course.x_pass_score">
                        <h6 style="margin:0">
                          <b-badge variant="danger">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg >= course.x_pass_score &&
        v.x_avg <= course.x_prom_score
        ">
                        <h6 style="margin:0">
                          <b-badge variant="success">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_avg > course.x_prom_score">
                        <h6 style="margin:0">
                          <b-badge variant="info">Prom.: {{ v.x_avg }}</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_homework_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_homework_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Tareas: {{ v.x_homework_percentage }} %</b-badge>
                        </h6>
                      </div>

                      <div v-if="v.x_attendance_percentage < course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="warning">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                      <div v-if="v.x_attendance_percentage > course.x_attendance">
                        <h6 style="margin:0">
                          <b-badge variant="success">Asist.: {{ v.x_attendance_percentage }} %</b-badge>
                        </h6>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(Diciembre)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Diciembre'">
                      <div v-for="(v, k) in jsonScores[v.id]" :key="'score' + k">
                        <div v-if="v < course.x_pass_score">
                          <h6 style="margin:0">
                            <b-badge variant="danger">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                        <div v-if="v >= course.x_pass_score &&
        v <= course.x_prom_score
        ">
                          <h6 style="margin:0">
                            <b-badge variant="success">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                        <div v-if="v > course.x_prom_score">
                          <h6 style="margin:0">
                            <b-badge variant="info">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </span>
                </template>
                <template #cell(Marzo)="data">
                  <span v-for="(v, k) in data.item.scorebook" :key="k">
                    <div v-if="v.x_periods_id[1] === 'Marzo'">
                      <div v-for="(v, k) in jsonScores[v.id]" :key="'score' + k">
                        <div v-if="v < course.x_pass_score">
                          <h6 style="margin:0">
                            <b-badge variant="danger">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                        <div v-if="v >= course.x_pass_score &&
        v <= course.x_prom_score
        ">
                          <h6 style="margin:0">
                            <b-badge variant="success">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                        <div v-if="v > course.x_prom_score">
                          <h6 style="margin:0">
                            <b-badge variant="info">{{ k }}: {{ v }}</b-badge>
                          </h6>
                        </div>
                      </div>
                    </div>
                  </span>
                </template>

                <template #cell(oral)="data">
                  <div>
                    <b-input style="width: 75px" type="number" v-model="data.item.scorebook.oral" v-if="editItem">
                    </b-input>
                    <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                      <div v-if="data.item.scorebook.oral == undefined || data.item.scorebook.oral == ''">A</div>
                      {{ data.item.scorebook.oral }}
                    </div>
                  </div>
                </template>
                <template #cell(escrito)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.escrito" v-if="editItem">
                  </b-input>
                  <div v-if="!editItem" style="font-size: 20px">
                    <div v-if="data.item.scorebook.escrito == undefined || data.item.scorebook.escrito == ''">A</div>
                    {{ data.item.scorebook.escrito }}
                  </div>
                </template>
                <template #cell(clase_oral)="data">
                  <div>
                    <b-input style="width: 75px" type="number" v-model="data.item.scorebook.clase_oral" v-if="editItem">
                    </b-input>
                    <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                      <div v-if="data.item.scorebook.clase_oral == undefined || data.item.scorebook.clase_oral == ''">A
                      </div>
                      {{ data.item.scorebook.clase_oral }}
                    </div>
                  </div>
                </template>
                <template #cell(clase_escrito)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.clase_escrito"
                    v-if="editItem"></b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div
                      v-if="data.item.scorebook.clase_escrito == undefined || data.item.scorebook.clase_escrito == ''">
                      A
                    </div>
                    {{ data.item.scorebook.clase_escrito }}
                  </div>
                </template>
                <template #cell(examen_oral)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.examen_oral" v-if="editItem">
                  </b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div v-if="data.item.scorebook.examen_oral == undefined || data.item.scorebook.examen_oral == ''">A
                    </div>
                    {{ data.item.scorebook.examen_oral }}
                  </div>
                </template>
                <template #cell(examen_escrito)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.examen_escrito"
                    v-if="editItem"></b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div
                      v-if="data.item.scorebook.examen_escrito == undefined || data.item.scorebook.examen_escrito == ''">
                      A</div>
                    {{ data.item.scorebook.examen_escrito }}
                  </div>
                </template>
                <template #cell(composición_1)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.composición_1"
                    v-if="editItem"></b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div
                      v-if="data.item.scorebook.composición_1 == undefined || data.item.scorebook.composición_1 == ''">
                      A
                    </div>
                    {{ data.item.scorebook.composición_1 }}
                  </div>
                </template>
                <template #cell(composición)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.composición" v-if="editItem">
                  </b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div v-if="data.item.scorebook.composición == undefined || data.item.scorebook.composición == ''">A
                    </div>
                    {{ data.item.scorebook.composición }}
                  </div>
                </template>

                <template #cell(composición_2)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.composición_2"
                    v-if="editItem"></b-input>
                  <div v-if="!editItem && data.item.scorebook.id" style="font-size: 20px">
                    <div
                      v-if="data.item.scorebook.composición_2 == undefined || data.item.scorebook.composición_2 == ''">
                      A
                    </div>
                    {{ data.item.scorebook.composición_2 }}
                  </div>
                </template>
                <template #cell(tareas)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.tareas" v-if="editItem">
                  </b-input>
                  <div v-if="!editItem && data.item.scorebook.tareas" style="font-size: 20px">
                    {{ data.item.scorebook.tareas }}
                  </div>
                </template>
                <template #cell(faltas)="data">
                  <b-input style="width: 75px" type="number" v-model="data.item.scorebook.faltas" v-if="editItem">
                  </b-input>
                  <div v-if="!editItem" style="font-size: 20px">
                    {{ data.item.scorebook.faltas }}
                  </div>
                </template>
                <template #cell(com_1)="data">
                  <b-form-select v-model="data.item.scorebook.com_1" :options="recordCommentOptions" v-if="editItem">
                  </b-form-select>
                  <div v-if="!editItem && data.item.scorebook.x_record_comment_string1" style="font-size: 15px">
                    {{ data.item.scorebook.x_record_comment_string1 }}
                  </div>
                </template>
                <template #cell(com_2)="data">
                  <b-form-select v-model="data.item.scorebook.com_2" :options="recordCommentOptions" v-if="editItem">
                  </b-form-select>
                  <div v-if="!editItem && data.item.scorebook.x_record_comment_string2" style="font-size: 15px">
                    {{ data.item.scorebook.x_record_comment_string2 }}
                  </div>
                </template>

                <template #row-details="data">
                  <b-tabs>
                    <b-tab title="Comentarios" active>
                      <b-table :items="data.item.comments" :fields="classCommentFields">
                        <template #cell(create_date)="data">
                          {{ data.item.create_uid[1] }} <br />
                          <div style="font-size:0.8em;color:gray">
                            {{ data.item.create_date }}
                          </div>
                        </template>
                      </b-table>
                      <b-button variant="outline-primary" size="sm" style="margin-right: 5px;"
                        @click="openCommentModal(data.item)">
                        + comentario</b-button>
                      <b-button variant="outline-primary" size="sm" @click="data.toggleDetails">Ocultar</b-button>
                    </b-tab>
                    <b-tab title="Notas">
                      <b-table :items="data.item.scorebook" :fields="classScorebookFields">
                        <template #cell(x_periods_id)="data">
                          <span style="font-size: 0.8em"><b>{{ data.item.x_periods_id[1] }}</b></span>
                        </template>
                        <template #cell(x_score)="data">
                          <b-row style="font-size: 0.8em">
                            <span v-for="(v, k) in data.item.x_score" :key="k">
                              <b-col v-if="(k !== 'id') & (k !== 'com_1') & (k != 'com_2')
        ">{{ k }} <br />
                                <b>{{ v }}</b>
                              </b-col>
                            </span>
                          </b-row>
                        </template>
                        <template #cell(actions)="data">
                          <b-button v-if="$store.state.user.currentGroups.includes(
        'Dirección'
      )
        " @click="deleteScorebook(data.item.id)">eliminar</b-button>
                        </template>
                      </b-table>
                    </b-tab>
                    <b-tab title="Historial">
                      <b-table :items="data.item.enrollments" :fields="[
        'x_year_id',
        'display_name',
        'teacher',
        'x_status',
        'x_GPA',
      ]">
                        <template #cell(x_year_id)="data">
                          {{ data.item.x_year_id[1] }}
                        </template>
                        <template #cell(teacher)="data">
                          {{ data.item.class.x_teacher_id[1] }}
                        </template>
                      </b-table>
                    </b-tab>
                  </b-tabs>
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
        <b-card class="mt-3" v-if="enrollmentsCanceled[0] !== undefined && !isLoading">
          <b-row>
            <b-col>
              <h5>Bajas</h5>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-table striped hover :items="enrollmentsCanceled" :fields="enrollmentFieldsCanceled">
                <template #cell(x_student_id)="data">
                  <b>{{ data.index + 1 }}</b> | {{ data.item.x_student_id[1] }}
                </template>
              </b-table>
            </b-col>
          </b-row>
        </b-card>
        <b-modal id="modal-comentario-alumno-clase" size="lg" title="Nuevo comentario">
          <div v-if="isLoading">Cargando</div>
          <div v-if="this.modalCommentStudent.x_student_id">
            <h5>{{ this.modalCommentStudent.x_student_id[1] }}</h5>
            <b-form-textarea v-model="modalNewCommentStudents" placeholder="Comentario..." rows="6" max-rows="6">
            </b-form-textarea>
          </div>
          <template #modal-footer="{ cancel }">
            <b-button variant="outline-secondary" @click="cancel">
              Cancelar
            </b-button>
            <b-button @click="guardarComentario()" variant="outline-primary">
              Guardar
            </b-button>
          </template>
        </b-modal>

        <b-modal id="modal-ver-alumno-data-enrollment" size="xl" :title="modalTitle">
          <div v-if="isLoadingModal">
            <h5>Cargando</h5> {{ modalLoadingMsg }}
          </div>
          <div v-if="modalEnrollmentMoreInfo && !isLoadingModal">
            <b-row>
              <b-col>
                <h4>{{ clase.x_name }} - {{ clase.x_year_id[1] !== 'False' ? clase.x_year_id[1] : clase.x_year }}</h4>
              </b-col>
              <b-col>
                <b-button style="float:right" variant="outline-secondary">Imprimir Certificado</b-button>
                <b-button style="float:right" class="mr-2" variant="outline-secondary">Imprimir Boletin</b-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5>Cursada</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table striped hover :items="scorebooksCoursePeriods" :fields="modalEnrollemtFields.course">
                  <template #cell(period)="data">
                    <b-link @click="deleteScorebook(data.item.id, modalEnrollmentMoreInfo)">x</b-link> {{
        data.item.period }}
                  </template>
                  <template #cell(tareas)="data">
                    {{ data.item.homeworkPercent }} %
                  </template>
                  <template #cell(faltas)="data">
                    {{ data.item.attdPercent }} %
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h5>Examen</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table striped hover :items="scorebooksExamPeriods" :fields="modalEnrollemtFields.exam">
                  <template #cell(period)="data">
                    <b-link @click="deleteExamPeriod(data.item.id, modalEnrollmentMoreInfo)">x</b-link>
                    {{ data.item.period }}
                  </template>
                  <template #cell(tareas)="data">
                    {{ data.item.homeworkPercent }} %
                  </template>
                  <template #cell(faltas)="data">
                    {{ data.item.attdPercent }} %
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h4>Comentarios</h4>
              </b-col>
              <b-col>
                <b-button v-if="!toggleNewCommentModal" style="float:right" @click="toggleNewComment()"
                  variant="outline-primary">Nuevo Comentario</b-button>
              </b-col>
            </b-row>
            <b-row v-if="toggleNewCommentModal" class="mt-2">
              <b-col>
                <b-form-textarea v-model="modalNewCommentStudents" placeholder="Comentario..." rows="6" max-rows="6">
                </b-form-textarea>
              </b-col>
            </b-row>
            <b-row v-if="toggleNewCommentModal" class="mt-2 mb-2">
              <b-col>
                <b-button style="float:right" variant="outline-primary" @click="saveNewComment()">Guardar</b-button>
                <b-button style="float:right" variant="outline-secondary" class="mr-2" @click="cancelNewComment()">
                  Cancelar</b-button>
              </b-col>
            </b-row>
            <b-row v-if="!toggleNewCommentModal">
              <b-col>
                <b-table striped hover :items="modalEnrollmentMoreInfo.comments" :fields="modalCommentsFields">
                  <template #cell(x_create_user)="data">
                    {{ data.item.x_create_user[1] }} <br>
                    <span style="font-size:0.8em"> {{ data.item.write_date }}</span>
                  </template>
                </b-table>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <h4>Historial</h4>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-table striped hover :items="modalEnrollmentMoreInfo.enrollments" :fields="modalHistoryFields">
                  <template #cell(x_year_id)="data">
                    {{ data.item.x_year_id[1] !== 'False' ? data.item.x_year_id[1] : data.item.clase.x_year }}
                  </template>
                  <template #cell(claseNombre)="data">
                    {{ data.item.claseNombre }}
                  </template>
                </b-table>
              </b-col>
            </b-row>
          </div>
          <template #modal-footer="{ cancel }">
            <b-button variant="outline-secondary" @click="cancel">
              Cerrar
            </b-button>
          </template>
        </b-modal>
      </div>
    </div>
    <b-modal hide-footer hide-header-close no-close-on-esc no-close-on-backdrop header-bg-variant="success"
      header-text-variant="light" id="edit-scorebook-success" size="m" centered title="Edición de Notas">
      <h6> Se cargaron las notas! </h6>
      <p class="pb-2"> Cambios guardados con éxito! </p>
      <b-button @click="hideSuccessModal()" variant="success">Listo!</b-button>

      <template #modal-footer="{ }">
      </template>
    </b-modal>
  </div>
</template>

<script>
import { ClassesService } from '@/services/classes.service'
import { ClassCommentService } from '@/services/class_comment.service'
import { RecordCommentService } from '@/services/record.comment.service'
import { CoursesService } from '@/services/courses.service'
import { EnrollmentsService } from '@/services/enrollments.service'
import { ScheduleService } from '@/services/schedule.service'
import { FamiliesService } from '@/services/families.service'
import { PeriodsService } from '@/services/periods.service'
import { PeriodTeacherNotesService } from '@/services/period.teacher.notes.service'
import { ScoreTypeService } from '@/services/score.type.service'
import { ScorebookService } from '@/services/scorebook.service'

export default {
  name: 'ver-clase',
  data () {
    return {
      isLoading: true,
      isLoadingClassInfo: true,
      isLoadingModal: true,
      loadingMsg: '',
      isLoadingPop: false,
      clase: {},
      course: {},
      schedule: [],
      claseTitle: '',
      enrollments: [],
      enrollmentsCanceled: [],
      enrollmentFields: [{ key: 'x_student_id', label: 'Alumno' }],
      originalEnrollmentFields: [],
      originalEnrollmentData: [],
      enrollmentFieldsCanceled: [
        { key: 'x_student_id', label: 'Alumno/a' },
        { key: 'write_date', label: 'Fecha Baja' }
      ],
      classCommentFields: [
        { key: 'create_date', label: 'Creado Por' },
        { key: 'x_comment', label: 'Comentario' }
      ],
      selectedPeriod: null,
      scoreTypes: [],
      teacherNotes: {},
      editItem: false,
      modalCommentStudent: {},
      modalNewCommentStudents: '',
      export_json_fields: {
        Nro: 'nro',
        Nombre: 'nombre'
      },
      export_json_data: [],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],

      classScorebookFields: [
        { key: 'x_student_id', label: 'Alumno/a' },
        { key: 'x_periods_id', label: 'Periodo' },
        { key: 'x_score', label: 'Notas' },
        { key: 'actions', label: 'Acciones' }
      ],

      modalEnrollmentMoreInfo: {},
      enrollmentsCursada: [],
      enrollmentsExamen: [],

      modalHistoryFields: [
        { key: 'x_year_id', label: 'Año' },
        { key: 'claseNombre', label: 'Clase' },
        { key: 'teacherNombre', label: 'Profesor/a' },
        { key: 'x_gpa', label: 'GPA' },
        { key: 'x_status', label: 'Estado' }
      ],
      modalCommentsFields: [
        { key: 'x_create_user', label: 'Creado por' },
        { key: 'x_comment', label: 'Comentario' }
      ],
      isBusy: false,
      toggleNewCommentModal: false,
      modalTitle: 'Mas Datos',
      modalLoadingMsg: '',
      loadingProgress: {
        status: false,
        value: 20,
        color: 'primary'
      },
      submitScoresProgress: {
        status: false,
        value: 20,
        color: 'primary'
      }
    }
  },
  computed: {
    jsonScores () {
      const ret = {}
      for (const key in this.enrollments) {
        for (const value in this.enrollments[key].scorebook) {
          ret[this.enrollments[key].scorebook[value].id] = JSON.parse(this.enrollments[key].scorebook[value].x_score)
        }
      }
      return ret
    },
    alumnosCursando () {
      // console.log('enrollments ', this.enrollments)
      return this.enrollments.length
    },
    alumnosBaja () {
      return this.enrollmentsCanceled.length
    },
    capacityPercentage () {
      const maxRoom = this.clase.x_capacity
      const totalStudents = this.enrollments.length - this.enrollmentsCanceled.length
      const barValue = totalStudents >= maxRoom ? 100 : (totalStudents * 100 / maxRoom)
      const barColor = barValue > 70 ? 'success' : barValue > 40 ? 'warning' : 'danger'
      return { barValue: barValue, barColor: barColor }
    },
    modalEnrollemtFields () {
      const ret = { course: [], exam: [] }
      // console.log('modal enrollment info: ', this.modalEnrollmentMoreInfo.scorebooks)
      if (this.modalEnrollmentMoreInfo.scorebooks !== undefined) {
        for (let i = 0; i < this.modalEnrollmentMoreInfo.scorebooks.length; i++) {
          const item = this.modalEnrollmentMoreInfo.scorebooks[i]
          if (item.period_type === 'course') {
            if (item.period !== undefined) {
              ret.course.push({ key: 'period', label: 'Periodo' })
            }
            if (item.avg !== undefined) {
              ret.course.push({ key: 'avg', label: 'Prom' })
            }
            if (item.clase_oral !== undefined) {
              ret.course.push({ key: 'clase_oral', label: 'Clase Oral' })
            }
            if (item.clase_escrito !== undefined) {
              ret.course.push({ key: 'clase_escrito', label: 'Clase Escrito' })
            }
            if (item.oral !== undefined) {
              ret.course.push({ key: 'oral', label: 'Clase Oral' })
            }
            if (item.escrito !== undefined) {
              ret.course.push({ key: 'escrito', label: 'Clase Escrito' })
            }
            if (item.examen_oral !== undefined) {
              ret.course.push({ key: 'examen_oral', label: 'Examen Oral' })
            }
            if (item.composición !== undefined) {
              ret.course.push({ key: 'composición', label: 'Composición' })
            }
            if (item.composición_1 !== undefined) {
              ret.course.push({ key: 'composición_1', label: 'Composición 1' })
            }
            if (item.composición_2 !== undefined) {
              ret.course.push({ key: 'composición_2', label: 'Composición 2' })
            }
            if (item.examen_escrito !== undefined) {
              ret.course.push({ key: 'examen_escrito', label: 'Examen Escrito' })
            }
            if (item.tareas !== undefined) {
              ret.course.push({ key: 'tareas', label: 'Tareas' })
            }
            if (item.faltas !== undefined) {
              ret.course.push({ key: 'faltas', label: 'Asistencia' })
            }
          } else {
            if (item.period !== undefined) {
              ret.exam.push({ key: 'period', label: 'Periodo' })
            }
            if (item.oral !== undefined) {
              ret.exam.push({ key: 'oral', label: 'Clase Oral' })
            }
            if (item.escrito !== undefined) {
              ret.exam.push({ key: 'escrito', label: 'Clase Escrito' })
            }
            if (item.examen_oral !== undefined) {
              ret.exam.push({ key: 'examen_oral', label: 'Examen Oral' })
            }
            if (item.composición !== undefined) {
              ret.exam.push({ key: 'composición', label: 'Composición' })
            }
            if (item.composición_1 !== undefined) {
              ret.exam.push({ key: 'composición_1', label: 'Composición 1' })
            }
            if (item.composición_2 !== undefined) {
              ret.exam.push({ key: 'composición_2', label: 'Composición 2' })
            }
            if (item.examen_escrito !== undefined) {
              ret.exam.push({ key: 'examen_escrito', label: 'Examen Escrito' })
            }
          }
        }
      }
      // console.log('modal enrollment fields ', ret)
      return ret
    },
    periodOptions () {
      const ret = []
      ret.push({ value: null, text: 'Resumen' })
      for (let i = 0; i < this.periods.length; i++) {
        ret.push({ value: i, text: this.periods[i].display_name })
      }
      return ret
    },
    periodCourseOptions () {
      const ret = []
      for (let i = 0; i < this.periods.length; i++) {
        if (this.periods[i].x_type === 'course') {
          ret.push(this.periods[i].id)
        }
      }
      return ret
    },
    periodExamOptions () {
      const ret = []
      for (let i = 0; i < this.periods.length; i++) {
        if (this.periods[i].x_type === 'exam') {
          ret.push(this.periods[i].id)
        }
      }
      return ret
    },

    scorebooksCoursePeriods () {
      const ret = []
      for (let i = 0; i < this.modalEnrollmentMoreInfo.scorebooks.length; i++) {
        if (this.periodCourseOptions.includes(this.modalEnrollmentMoreInfo.scorebooks[i].period_id)) {
          ret.push(this.modalEnrollmentMoreInfo.scorebooks[i])
        }
      }
      // console.log('scorebooks modal enrolment more info ', this.modalEnrollmentMoreInfo.enrollments)
      return ret
    },
    scorebooksExamPeriods () {
      const ret = []
      for (let i = 0; i < this.modalEnrollmentMoreInfo.scorebooks.length; i++) {
        if (this.periodExamOptions.includes(this.modalEnrollmentMoreInfo.scorebooks[i].period_id)) {
          // console.log('exams ', this.modalEnrollmentMoreInfo.scorebooks[i])
          ret.push(this.modalEnrollmentMoreInfo.scorebooks[i])
        }
      }

      return ret
    },
    modalEnrollemtCourseFields () {
      return []
    },
    recordCommentOptions () {
      const ret = []
      for (let i = 0; i < this.recordComments.length; i++) {
        ret.push({
          value: this.recordComments[i].id,
          text:
            this.recordComments[i].x_title +
            ' - ' +
            this.recordComments[i].x_comment
        })
      }
      return ret
    },
    bestGPA () {
      // calculation to obtain the bestGPA for the class
      const allProms = []
      for (let i = 0; i < this.enrollments.length; i++) {
        if (this.enrollments[i] && this.enrollments[i].resumenCursada && this.enrollments[i].resumenCursada.Prom) {
          allProms.push(parseFloat(this.enrollments[i].resumenCursada.Prom))
        }
      }
      const maxProm = (allProms.length > 0) ? Math.max(...allProms) : 0
      return maxProm
    }
  },
  watch: {
    async selectedPeriod (newVal) {
      this.isLoading = true
      await this.updateScorebooks(newVal)
      this.isLoading = false
    }
  },

  async created () {
    // cargando clase ----
    this.loadingMsg = 'Cargando Clase'
    const allCoursePeriods = []
    const item = await ClassesService.read([parseInt(this.$route.params.id)])
    this.clase = item[0]
    // console.log('clase -------> ', this.clase)
    this.loadingMsg = 'Cargando Periodos'
    this.periods = await PeriodsService.list({
      x_year_id: this.clase.x_year_id[0]
    })
    for (let i = 0; i < this.periods.length; i++) {
      this.enrollmentFields.push(
        this.periods[i].display_name.replace(' ', '_')
      )
      // Ids for periods of type 'course', this is used later to obtain student total GPA
      if (this.periods[i].x_type === 'course') {
        allCoursePeriods.push(this.periods[i].id)
      }
      // this.periodsTeacherNotes = await PeriodTeacherNotesService.list({})
    }
    this.originalEnrollmentFields = this.enrollmentFields
    this.loadingMsg = 'Cargando Opciones de Comentario'
    this.recordComments = await RecordCommentService.list(
      {},
      { order: 'x_title asc' }
    )
    this.loadingMsg = 'Cargando Curso'
    const course = await CoursesService.read(
      this.clase.x_product_template_id[0]
    )
    this.course = course[0]
    this.claseTitle = this.clase.x_name
    this.loadingMsg = 'Cargando Inscripciones'
    this.enrollments = await EnrollmentsService.read(
      this.clase.x_enrollments_ids
    )
    const maxProgress = this.enrollments.length
    this.isLoadingClassInfo = false
    // Loading students
    this.loadingProgress = {
      status: true,
      value: 0,
      color: 'primary'
    }
    for (let i = 0; i < this.enrollments.length; i++) {
      const student = await FamiliesService.read(this.enrollments[i].x_student_id[0], ['x_skip_family_name', 'name'])
      if (student[0].x_skip_family_name) {
        this.enrollments[i].x_student_id[1] = student[0].name
      }
    }

    this.enrollments.sort((a, b) =>

      a.x_student_id[1].localeCompare(b.x_student_id[1])
    )

    for (let i = 0; i < this.enrollments.length; i++) {
      this.loadingMsg = 'Cargando Inscripciones - ' + this.enrollments[i].x_student_id[1]
      if (this.enrollments[i].x_status === 'canceled') {
        this.enrollmentsCanceled.push(this.enrollments[i])
        this.enrollments.splice(i, 1)
        i--
      } else {
        this.enrollments[i].scorebook = await ScorebookService.list(
          {
            x_res_partner_id: this.enrollments[i].x_student_id[0],
            x_class_id: this.clase.id
          },
          [],
          { order: 'x_periods_id asc' }
        )
        this.export_json_data.push({
          nro: i + 1,
          nombre: this.enrollments[i].x_student_id[1]
        })
        // -- Total GPA per student is calculated using the x_avg for each scorebook
        // this scorebook gpa is calculated only for the periods Id of type 'course' ( in array allCoursePeriods)
        let promedioGlobal = 0 // initialize global GPA to 0
        let validCoursePeriods = 0 // initialize course period to 0
        // Iterate through the 'scorebook' array of the current enrollment
        for (let j = 0; j < this.enrollments[i].scorebook.length; j++) {
          const isValidPeriod = (this.enrollments[i].scorebook[j] && !Number.isNaN(this.enrollments[i].scorebook[j].x_avg) && (this.enrollments[i].scorebook[j].x_avg > 0))
          const isIdInScorebook = allCoursePeriods.includes(this.enrollments[i].scorebook[j].x_periods_id[0])
          // If the ID is in 'allCoursePeriods' and 'x_avg' is defined, update 'promedioGlobal'
          if (isValidPeriod) {
            validCoursePeriods = validCoursePeriods + 1
          }
          if (isIdInScorebook && this.enrollments[i].scorebook[j].x_avg) {
            promedioGlobal += parseFloat(this.enrollments[i].scorebook[j].x_avg)
          }
        }
        // console.log(' laoding ', i, 'value: ', Math.round((i * 100) / maxProgress), '/', maxProgress)
        // Calculate the average ('Prom') and update 'resumenCursada' in the current enrollment
        this.enrollments[i].resumenCursada = { Prom: (promedioGlobal / validCoursePeriods).toFixed(2) }
      }
      this.loadingProgress = {
        status: true,
        value: Math.round((i * 100) / maxProgress),
        color: (i === maxProgress - 1 - this.enrollmentsCanceled.length) ? 'success' : 'primary'
      }
    }
    this.originalEnrollmentData = this.enrollments
    this.schedule = await ScheduleService.list({ x_class_id: this.clase.id })
    this.isLoading = false
    this.loadingProgress = {
      status: false,
      value: 0,
      color: 'success'
    }
    // console.log(this.jsonScores)
    // console.log('bestGPA: ' + this.bestGPA)
  },
  methods: {
    toggleNewComment () {
      this.toggleNewCommentModal = true
    },
    async saveNewComment () {
      const newComment = {
        x_comment: this.modalNewCommentStudents,
        x_res_partner_id: this.modalEnrollmentMoreInfo.x_student_id[0],
        x_create_user: this.$store.state.user.currentUser.id
      }
      await ClassCommentService.create(newComment)
      this.modalEnrollmentMoreInfo.comments = await ClassCommentService.list(
        { x_res_partner_id: this.modalEnrollmentMoreInfo.x_student_id[0] },
        { order: 'id desc', limit: 0 }
      )
      this.modalNewCommentStudents = ''
      this.toggleNewCommentModal = false
    },
    cancelNewComment () {
      this.toggleNewCommentModal = false
    },
    // async refreshMoreInfoModalInfo (enrollment) {
    //   this.modalLoadingMsg = 'Cargando Notas'
    //   this.isLoadingModal = true
    //   enrollment.scorebooks = []
    //   this.modalEnrollmentMoreInfo.scorebooks = []
    //   console.log('more modal info: ', this.modalEnrollmentMoreInfo)
    //   enrollment.scorebook = await ScorebookService.list(
    //     {
    //       x_res_partner_id: enrollment.x_student_id[0],
    //       x_class_id: this.clase.id
    //     },
    //     [],
    //     { order: 'x_periods_id asc' }
    //   )
    //   console.log('scorebooks: ', enrollment.scorebook)
    //   for (let i = 0; i < enrollment.scorebook.length; i++) {
    //     let periodType = ''
    //     for (let j = 0; j < this.periods.length; j++) {
    //       if (this.periods[j].id === enrollment.scorebook[i].x_periods_id[0]) {
    //         periodType = this.periods[j].x_type
    //       }
    //     }
    //     let newScorebook = {
    //       period: enrollment.scorebook[i].x_periods_id[1],
    //       period_id: enrollment.scorebook[i].x_periods_id[0],
    //       period_type: periodType,
    //       avg: enrollment.scorebook[i].x_avg,
    //       homeworkPercent: enrollment.scorebook[i].x_homework_percentage,
    //       attdPercent: enrollment.scorebook[i].x_attendance_percentage
    //     }

    //     // console.log('new scorebook ', newScorebook)
    //     newScorebook = { ...newScorebook, ...ScorebookService.decodeScore(enrollment.scorebook[i]) }
    //     // enrollment.scorebooks.push(newScorebook)
    //     enrollment.scorebooks = [...enrollment.scorebooks]
    //     // this.modalLoadingMsg = 'Cargando Historial'
    //     enrollment.enrollments = await EnrollmentsService.list(
    //       { x_student_id: enrollment.x_student_id[0] },
    //       [],
    //       { order: 'x_year_id desc' }
    //     )

    //     for (let j = 0; j < enrollment.enrollments.length; j++) {
    //       enrollment.enrollments[j].clase = (
    //         await ClassesService.read(
    //           enrollment.enrollments[j].x_class_id[0]
    //         )
    //       )[0]
    //       enrollment.enrollments[j].claseNombre = enrollment.enrollments[j].clase.x_product_template_id[1]
    //       enrollment.enrollments[j].teacherNombre = enrollment.enrollments[j].clase.x_teacher_id[1]
    //     }
    //     // console.log('enrollment con clases y teachers: ', enrollment)
    //     // this.modalLoadingMsg = 'Cargando Comentarios'
    //     enrollment.comments = await ClassCommentService.list(
    //       { x_res_partner_id: enrollment.x_student_id[0] },
    //       { order: 'id desc', limit: 0 }
    //     )
    //   }

    //   this.modalEnrollmentMoreInfo = { ...enrollment } // Replace the whole object
    //   console.log('modal enrollment info:', this.modalEnrollmentMoreInfo)
    //   this.isLoadingModal = false
    // },
    async refreshMoreInfoModalInfo (enrollment) {
      try {
        // Start loading
        this.modalLoadingMsg = 'Cargando Notas'
        this.isLoadingModal = true

        // Reset enrollment data
        enrollment.scorebooks = []
        enrollment.enrollments = []
        enrollment.comments = []
        console.log('Starting refresh for enrollment:', enrollment)

        // Fetch scorebooks
        const scorebooks = await ScorebookService.list(
          { x_res_partner_id: enrollment.x_student_id[0], x_class_id: this.clase.id },
          [],
          { order: 'x_periods_id asc' }
        )
        console.log('Fetched scorebooks:', scorebooks)

        // Process scorebooks
        enrollment.scorebooks = scorebooks.map(scorebook => {
          const periodType = this.periods.find(period => period.id === scorebook.x_periods_id[0])?.x_type || ''
          return {
            period: scorebook.x_periods_id[1],
            period_id: scorebook.x_periods_id[0],
            period_type: periodType,
            avg: scorebook.x_avg,
            homeworkPercent: scorebook.x_homework_percentage,
            attdPercent: scorebook.x_attendance_percentage,
            ...ScorebookService.decodeScore(scorebook)
          }
        })

        console.log('Processed scorebooks:', enrollment.scorebooks)

        // Fetch enrollments
        const enrollments = await EnrollmentsService.list(
          { x_student_id: enrollment.x_student_id[0] },
          [],
          { order: 'x_year_id desc' }
        )
        console.log('Fetched enrollments:', enrollments)

        // Process enrollments
        enrollment.enrollments = await Promise.all(
          enrollments.map(async enrollmentItem => {
            const clase = await ClassesService.read(enrollmentItem.x_class_id[0])
            return {
              ...enrollmentItem,
              clase: clase[0],
              claseNombre: clase[0].x_product_template_id[1],
              teacherNombre: clase[0].x_teacher_id[1]
            }
          })
        )

        console.log('Processed enrollments:', enrollment.enrollments)

        // Fetch comments
        enrollment.comments = await ClassCommentService.list(
          { x_res_partner_id: enrollment.x_student_id[0] },
          { order: 'id desc', limit: 0 }
        )
        console.log('Fetched comments:', enrollment.comments)

        // Trigger reactivity
        this.modalEnrollmentMoreInfo = { ...enrollment }
        console.log('Updated modalEnrollmentMoreInfo:', this.modalEnrollmentMoreInfo)

        // Stop loading
        this.isLoadingModal = false
      } catch (error) {
        console.error('Error during refreshMoreInfoModalInfo:', error)
        this.isLoadingModal = false // Ensure loading stops
      }
    },

    async openMoreInfoModal (enrollment) {
      // console.log('entrollment ver: ', enrollment)
      this.$bvModal.show('modal-ver-alumno-data-enrollment')
      this.modalTitle = enrollment.x_student_id[1]
      await this.refreshMoreInfoModalInfo(enrollment)
    },

    async deleteScorebook (id, enrollment) {
      console.log('delete scorebook: ', id)
      try {
        const deletedSB = await ScorebookService.delete(id)
        console.log('deleted SB', deletedSB)
        if (deletedSB) {
          await this.refreshMoreInfoModalInfo(enrollment)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async deleteExamPeriod (id, enrollment) {
      console.log('delete exam period: ', id, enrollment)
      try {
        const deletedSB = await ScorebookService.delete(id)
        console.log('deleted SB', deletedSB)
        if (deletedSB) {
          await this.refreshMoreInfoModalInfo(enrollment)
        }
      } catch (error) {
        console.log(error)
      }
    },

    async updateListado () {
      // console.log('actualizando listado .... ')
      this.loadingProgress = {
        status: true,
        value: 0,
        color: 'primary'
      }
      const maxProgress = this.enrollments.length
      for (let i = 0; i < this.enrollments.length; i++) {
        this.loadingMsg = 'Cargando Inscripciones - ' + this.enrollments[i].x_student_id[1]
        if (this.enrollments[i].x_status === 'canceled') {
          this.enrollmentsCanceled.push(this.enrollments[i])
          this.enrollments.splice(i, 1)
          i--
        } else {
          this.enrollments[i].enrollments = await EnrollmentsService.list(
            { x_student_id: this.enrollments[i].x_student_id[0] },
            [],
            { order: 'x_year_id desc' }
          )
          for (let j = 0; j < this.enrollments[i].enrollments.length; j++) {
            this.enrollments[i].enrollments[j].class = (
              await ClassesService.read(
                this.enrollments[i].enrollments[j].x_class_id[0]
              )
            )[0]
          }
          this.enrollments[i].scorebook = await ScorebookService.list(
            {
              x_res_partner_id: this.enrollments[i].x_student_id[0],
              x_class_id: this.clase.id
            },
            [],
            { order: 'x_periods_id asc' }
          )
          for (let j = 0; j < this.enrollments[i].scorebook.length; j++) {
            this.enrollments[i].scorebook[j].x_score =
              ScorebookService.decodeScore(this.enrollments[i].scorebook[j])
          }
          this.enrollments[i].comments = await ClassCommentService.list(
            { x_res_partner_id: this.enrollments[i].x_student_id[0] },
            { order: 'id desc', limit: 0 }
          )
          this.export_json_data.push({
            nro: i + 1,
            nombre: this.enrollments[i].x_student_id[1]
          })
          // console.log(' laoding ', i, 'value: ', Math.round((i * 100) / maxProgress), '/', maxProgress)
        }
        this.loadingProgress = {
          status: true,
          value: Math.round((i * 100) / maxProgress),
          color: (i === maxProgress - 1 - this.enrollmentsCanceled.length) ? 'success' : 'primary'
        }
      }
      this.originalEnrollmentData = this.enrollments
      this.loadingProgress = {
        status: false,
        value: 0,
        color: 'success'
      }
    },
    async guardarComentario () {
      this.isLoading = true
      if (this.modalNewCommentStudents !== '') {
        const newComment = {
          x_comment: this.modalNewCommentStudents,
          x_res_partner_id: this.modalCommentStudent.x_student_id[0],
          x_create_user: this.$store.state.user.currentUser.id
        }
        await ClassCommentService.create(newComment)
        this.modalNewCommentStudents = ''
        for (let i = 0; i < this.enrollments.length; i++) {
          this.enrollments[i].comments = await ClassCommentService.list(
            { x_res_partner_id: this.enrollments[i].x_student_id[0] },
            { order: 'id desc', limit: 0 }
          )
        }
      }
      this.$bvModal.hide('modal-comentario-alumno-clase')
      this.isLoading = false
    },
    openCommentModal (student) {
      this.modalCommentStudent = student
      this.$bvModal.show('modal-comentario-alumno-clase')
      this.isLoading = false
    },

    async guardarNotas () {
      this.isLoading = true
      this.loadingMsg = 'Guardando Notas'
      // console.log('guardando notas .... ')
      this.loadingProgress = {
        status: true,
        value: 0,
        color: 'primary'
      }
      const pr = []
      // const maxProgress = this.enrollments.length
      for (let i = 0; i < this.enrollments.length; i++) {
        // console.log('evaluando alumno/a :', this.enrollments[i].x_student_id[1])
        const keys = Object.keys(this.enrollments[i].scorebook)
        let update = false
        for (let j = 0; j < keys.length; j++) {
          // console.log('revisando ', keys[j])
          if (this.enrollments[i].scorebook[keys[j]] !== '') {
            update = true
            // console.log('actualizar ', keys[j])
          }
        }

        if (update) {
          // console.log('proceso de actualización ', this.enrollments[i].x_student_id[1])
          const scorebook = ScorebookService.encodeScore(
            this.enrollments[i].scorebook,
            this.schedule,
            this.teacherNotes,
            this.periods[this.selectedPeriod],
            this.scoreTypes
          )
          if (this.periods[this.selectedPeriod].x_type === 'exam') {
            // console.log('tipo de período: exámen')
            // console.log(this.periods[this.selectedPeriod])
            // console.log(scorebook)
            if (scorebook.id !== undefined) {
              //  console.log('actualizar nota exámen')
              pr.push(ScorebookService.update(scorebook.id, scorebook))
            } else {
              //  console.log('crear nota exámen')
              scorebook.x_enrollment_id = this.enrollments[i].id
              scorebook.x_res_partner_id = this.enrollments[i].x_student_id[0]
              scorebook.x_class_id = this.enrollments[i].x_class_id[0]
              scorebook.x_periods_id = this.periods[this.selectedPeriod].id

              pr.push(ScorebookService.create(scorebook))
            }
          } else {
            //  console.log('actualizar comentarios')
            if (scorebook.x_record_comment1_id !== undefined) {
              for (let j = 0; j < this.recordComments.length; j++) {
                if (this.recordComments[j].id === scorebook.x_record_comment1_id) {
                  scorebook.x_record_comment_string1 = this.recordComments[j].x_comment
                }
              }
              // scorebook.x_record_comment_string1 = this.recordComments[scorebook.x_record_comment1_id].x_comment
              // scorebook.x_record_comment1_id = this.recordComments[scorebook.x_record_comment1_id].id
            }
            if (scorebook.x_record_comment2_id !== undefined) {
              for (let j = 0; j < this.recordComments.length; j++) {
                if (this.recordComments[j].id === scorebook.x_record_comment2_id) {
                  scorebook.x_record_comment_string2 = this.recordComments[j].x_comment
                }
              }
              // scorebook.x_record_comment_string2 = this.recordComments[scorebook.x_record_comment2_id].x_comment
              // scorebook.x_record_comment2_id = this.recordComments[scorebook.x_record_comment2_id].id
            }

            if (Number.isNaN(scorebook.x_homework_percentage)) {
              scorebook.x_homework_percentage = 0
            }
            if (scorebook.id !== undefined) {
              pr.push(ScorebookService.update(scorebook.id, scorebook))
            } else {
              scorebook.x_enrollment_id = this.enrollments[i].id
              scorebook.x_res_partner_id = this.enrollments[i].x_student_id[0]
              scorebook.x_class_id = this.enrollments[i].x_class_id[0]
              scorebook.x_periods_id = this.periods[this.selectedPeriod].id
              pr.push(ScorebookService.create(scorebook))
            }
          }
        }
      }
      try {
        await Promise.all(pr)
        this.$bvModal.show('edit-scorebook-success')
      } catch (error) {
        console.log('error en el guardado de notas ', error)
      }
    },
    async hideSuccessModal () {
      // close modal
      this.loadingProgress = {
        status: false,
        value: 0,
        color: 'success'
      }
      this.editItem = false
      this.isLoading = false
      this.$bvModal.hide('edit-scorebook-success')
      await this.updateClassScore()
    },
    async updateClassScore () {
      //  console.log('actualizar notas')
      for (var i = 0; i < this.enrollments.length; i++) {
        const studentScorebook = await ScorebookService.list({
          x_class_id: this.clase.id,
          x_res_partner_id: this.enrollments[i].x_student_id[0]
        })
        await this.processScorebooksCourseStatus(this.enrollments[i], studentScorebook)
      }
      await this.updateScorebooks(this.selectedPeriod)
    },
    async processScorebooksCourseStatus (enrollment, scorebooks) {
      //  console.log('procesar estado del curso ..... ', enrollment, scorebooks)
      const coursePeriods = []
      const examPeriods = []
      const courseScorebooks = []
      const examScorebooks = []
      for (var i = 0; i < this.periods.length; i++) {
        if (this.periods[i].x_type === 'course') {
          coursePeriods.push(this.periods[i])
          for (var j = 0; j < scorebooks.length; j++) {
            if (this.periods[i].id === scorebooks[j].x_periods_id[0]) {
              courseScorebooks[i] = scorebooks[j]
            }
          }
        } else {
          examPeriods.push(this.periods[i])
          for (j = 0; j < scorebooks.length; j++) {
            if (this.periods[i].id === scorebooks[j].x_periods_id[0]) {
              examScorebooks[i] = scorebooks[j]
            }
          }
        }
      }
      console.log('course scorebooks: ', courseScorebooks.length)
      console.log('course periods: ', coursePeriods.length)
      if (courseScorebooks.length === coursePeriods.length) {
        console.log('SE CALCULA EL PROMEDIO DE LA CURSADA')
        const gpl = {}
        const promotion = {}
        for (let j = 0; j < courseScorebooks.length; j++) {
          const decodedScorebook = ScorebookService.decodeScore(courseScorebooks[j], this.course)
          for (let ii = 0; ii < Object.keys(decodedScorebook).length; ii++) {
            if (Object.keys(decodedScorebook)[ii] !== 'com_1' &&
              Object.keys(decodedScorebook)[ii] !== 'com_2' &&
              Object.keys(decodedScorebook)[ii] !== 'x_record_comment_string1' &&
              Object.keys(decodedScorebook)[ii] !== 'x_record_comment_string2' &&
              Object.keys(decodedScorebook)[ii] !== 'tareas' &&
              Object.keys(decodedScorebook)[ii] !== 'faltas' &&
              Object.keys(decodedScorebook)[ii] !== 'id') {
              if (gpl[Object.keys(decodedScorebook)[ii]] === undefined) {
                gpl[Object.keys(decodedScorebook)[ii]] = 0
              }
              gpl[Object.keys(decodedScorebook)[ii]] += decodedScorebook[Object.keys(decodedScorebook)[ii]]
              for (const index in this.scoreTypes) {
                if (Object.keys(decodedScorebook)[ii].replace('_', ' ') === this.scoreTypes[index].x_name.toLowerCase()) {
                  if (this.scoreTypes[index].x_promotion[0] !== undefined) {
                    if (promotion[this.scoreTypes[index].x_promotion[1].toLowerCase()] === undefined) {
                      promotion[this.scoreTypes[index].x_promotion[1].toLowerCase()] = { data: [], promotes: this.scoreTypes[index].x_promotion, score: 0, count: 0 }
                    }
                    promotion[this.scoreTypes[index].x_promotion[1].toLowerCase()].count++
                    promotion[this.scoreTypes[index].x_promotion[1].toLowerCase()].score += decodedScorebook[Object.keys(decodedScorebook)[ii]]
                  }
                }
              }
            }
          }
        }
        const doneGpl = {}
        for (const item in gpl) {
          doneGpl[item] = (gpl[item] / coursePeriods.length).toFixed(2)
        }
        if (Object.keys(promotion).length > 0) {
          const newScore = {}
          for (const item2 in promotion) {
            if ((promotion[item2].score / promotion[item2].count).toFixed(2) > this.course.x_prom_score) {
              newScore[item2] = (promotion[item2].score / promotion[item2].count).toFixed(2)
            }
          }
          if (Object.keys(newScore).length > 0) {
            // console.log(newScore, examScorebooks, examPeriods, courseScorebooks, {
            //   x_periods_id: examPeriods[0].id,
            //   x_res_partner_id: enrollment.x_student_id[0],
            //   x_class_id: enrollment.x_class_id[0]
            // })
            const dicScorebook = (await ScorebookService.searchRead({
              x_periods_id: examPeriods[0].id,
              x_res_partner_id: enrollment.x_student_id[0],
              x_class_id: enrollment.x_class_id[0]
            }))[0]

            if (dicScorebook !== undefined) {
              const dicScore = JSON.parse(dicScorebook.x_score)
              // console.log(JSON.parse(dicScorebook.x_score), newScore)
              for (const i in newScore) {
                // console.log(i)
                dicScore[i] = parseFloat(newScore[i])
              }
              await ScorebookService.update([dicScorebook.id], { x_score: JSON.stringify(dicScore) })
            } else {
              const dicScore = {
                x_periods_id: examPeriods[0].id,
                x_enrollment_id: enrollment.id,
                x_res_partner_id: enrollment.x_student_id[0],
                x_class_id: enrollment.x_class_id[0],
                x_score: JSON.stringify(newScore)
              }
              await ScorebookService.create(dicScore)
            }
          }
        }
        await EnrollmentsService.update([enrollment.id], { x_GPA: JSON.stringify(doneGpl), x_status: 'exam' })
      }
    },
    async cancelarCarga () {
      this.isLoading = true
      await this.updateScorebooks(this.selectedPeriod)
      this.editItem = false
      this.isLoading = false
    },
    async getClassComments () { },
    async updateScorebooks (index) {
      this.loadingMsg = 'Actualizando boletines: '
      // console.log('period index: ', index)
      if (index === null) {
        this.isLoading = true
        this.teacherNotes = {}
        this.scoreTypes = []
        this.enrollmentFields = this.originalEnrollmentFields
        await this.updateListado()
        this.isLoading = false
      } else {
        this.teacherNotes = (
          await PeriodTeacherNotesService.list({
            x_period_id: this.periods[index].id,
            x_class_id: this.clase.id
          })
        )[0]
        if (this.teacherNotes === undefined) {
          this.teacherNotes = {
            x_homework_count: 0,
            x_period_id: this.periods[index].id,
            x_class_id: this.clase.id
          }
        }
        this.scoreTypes = await ScoreTypeService.list({
          x_period_id: this.periods[index].id,
          x_advanced_class: this.course.x_advanced_class
        })
        this.enrollmentFields = [{ key: 'x_student_id', label: 'Alumno/a' }]
        for (let i = 0; i < this.scoreTypes.length; i++) {
          this.enrollmentFields.push(
            this.scoreTypes[i].display_name.trim().replace(' ', '_')
          )
        }
        if (this.periods[index].x_type !== 'exam') {
          this.enrollmentFields.push('Tareas')
          this.enrollmentFields.push('Faltas')
          this.enrollmentFields.push('Com_1')
          this.enrollmentFields.push('Com_2')
        }
        this.loadingProgress = {
          status: true,
          value: 0,
          color: 'primary'
        }
        const maxProgress = this.enrollments.length
        for (let i = 0; i < this.enrollments.length; i++) {
          const scorebook = await ScorebookService.list({
            x_periods_id: this.periods[this.selectedPeriod].id,
            x_class_id: this.clase.id,
            x_res_partner_id: this.enrollments[i].x_student_id[0]
          })
          if (scorebook[0] !== undefined) {
            this.enrollments[i].scorebook = ScorebookService.decodeScore(scorebook[0], this.course)
          } else {
            this.enrollments[i].scorebook = {
              oral: '',
              escrito: '',
              examen_oral: '',
              examen_escrito: '',
              composición_1: '',
              composición: '',
              tareas: '',
              faltas: '',
              com_1: '',
              com_2: ''
            }
          }
          this.loadingProgress = {
            status: true,
            value: Math.round((i * 100) / maxProgress),
            color: (i === maxProgress - 1 - this.enrollmentsCanceled.length) ? 'success' : 'primary'
          }
        }
      }
      this.loadingProgress = {
        status: false,
        value: 0,
        color: 'success'
      }
    },
    async gotoFamilia (item) {
      const student = await FamiliesService.read([item.x_student_id[0]])
      // this.$router.push({ path: '/families/' + student[0].parent_id[0] })
      // const routeData = this.$router.resolve({ name: 'routeName', query: {data: "someData"}});
      window.open('/families/' + student[0].parent_id[0], '_blank')
    },
    async cargarNotas () {
      this.editItem = true
    },
    async EditarHomeworkCount () {
      this.isLoading = true
      this.loadingMsg = 'guardando Tareas'
      if (this.teacherNotes.id === undefined) {
        await PeriodTeacherNotesService.create(this.teacherNotes)
      } else {
        await PeriodTeacherNotesService.update([this.teacherNotes.id], {
          x_homework_count: parseInt(this.teacherNotes.x_homework_count)
        })
      }
      this.isLoading = false
    },
    async exportEnrollments () { }
  }
}
</script>

<style lang="scss" scoped>
#progress-row {
  position: fixed;
  top: 2;
  width: 100%;
  z-index: 1000;
  /* Adjust z-index as needed */
}
</style>
